import React, { useRef, useState } from 'react'
import Button from '../../../../../utils/components/Button/Button'
import CardList from '../../../../../utils/components/CardList/CardList'
import style from './ProductCreate.module.css'
const ProductCreate = ({ formik, categories, subCategories, presentations, product, isEdit }) => {
    const [imgSrc, setImgSrc] = useState(null)
    const ref = useRef(null)
    return (
        <div className='container-page scroll-menu'>
            <div className="container-page-90">
                <div className={style.title}>{isEdit ? 'Editar' : 'Crear'} producto</div>
                <div className={`${style.img_container} mt-5`}>
                    <input onChange={(event) => {
                        if (event.target.files[0] && event.target.files[0].type.includes('image')) {
                            setImgSrc(URL.createObjectURL(event.target.files[0]))
                            formik.setFieldValue("image", event.target.files[0])
                        }

                    }} type='file' ref={ref} accept="image" />
                    <CardList defaultImg={""} picture={imgSrc ? imgSrc : product && product.image && product.image.url.origin} textOne={"Imagen"} onClick={() => { ref.current.click() }} />
                    <div className={style.error}>{formik.errors.image}</div>

                </div>
                <div className={style.inputs_grid}>
                    <div className={style.input_error_container}>
                        <input className={style.input} placeholder="Codigo" name="code" onChange={formik.handleChange} value={formik.values.code} />
                        <div className={style.error}>{formik.errors.categoryId}</div>
                    </div>
                    <div className={style.input_error_container}>
                        <input
                            className={style.input}
                            placeholder="Nombre"
                            name="name"
                            onChange={formik.handleChange}
                            value={formik.values.name}
                        />
                        <div className={style.error}>{formik.errors.name}</div>
                    </div>
                    <div className={style.input_error_container}>
                        <select className={style.input} name="categoryId" value={formik.values.categoryId} onChange={formik.handleChange}>
                            <option value="">Categoría</option>
                            {
                                categories.map(category => (
                                    <option key={category._id} value={category._id}>{category.name}</option>
                                ))
                            }
                        </select>
                        <div className={style.error}>{formik.errors.categoryId}</div>
                    </div>
                    <div className={style.input_error_container}>
                        <select className={style.input} name='subcategoryId' value={formik.values.subcategoryId} onChange={formik.handleChange}>
                            <option>Sub-categoría</option>
                            {
                                subCategories.map(subCategory => (
                                    <option key={subCategory._id} value={subCategory._id}>{subCategory.name}</option>
                                ))
                            }
                        </select>
                        <div className={style.error}>{formik.errors.subcategoryId}</div>
                    </div>
                </div>
                <div className={style.input_container}>
                    <div className={style.input_error_container}>
                        <select className={style.input} name="presentationId" value={formik.values.presentationId} onChange={formik.handleChange}>
                            <option value="">Presentación</option>
                            {
                                presentations.map(presentation => (
                                    <option key={presentation._id} value={presentation._id}>{presentation.name}</option>
                                ))
                            }
                        </select>
                        <div className={style.error}>{formik.errors.presentationId}</div>
                    </div>
                    <div className={style.input_error_container}>
                        <div className='column centerItems'>
                            <input className={style.input} type="number" min={0} placeholder="Precio" name="price" onChange={formik.handleChange} value={formik.values.price} />
                        </div>

                        <div className={style.error}>{formik.errors.price}</div>
                    </div>
                    <div className={style.input_error_container}>
                        <div className='column centerItems'>
                            <input className={style.input} type="number" min={0} placeholder="Costo de produccion" name="productCost" onChange={formik.handleChange} value={formik.values.productCost} />
                        </div>

                        <div className={style.error}>{formik.errors.productCost}</div>
                    </div>
                </div>
                <div>
                    <div className={style.third_input_container}>
                        <div>
                            <textarea className={style.textarea} placeholder="Instrucciones" name="instructions" onChange={formik.handleChange} value={formik.values.instructions} />
                            <div className={style.error}>{formik.errors.instructions}</div>
                        </div>
                        <div>
                            <textarea className={style.textarea} placeholder="Ingredientes" name="ingredients" onChange={formik.handleChange} value={formik.values.ingredients} />
                            <div className={style.error}>{formik.errors.ingredients}</div>

                        </div>

                        <div>
                            <textarea className={style.textarea} placeholder="Tamaño del producto" name="productsize" onChange={formik.handleChange} value={formik.values.productsize} />
                            <div className={style.error}>{formik.errors.productsize}</div>

                        </div>


                    </div>
                </div>

                <div>
                    <div className={style.input_error_container}>
                        <div className={style.input_container}>
                            <textarea className={style.textarea} placeholder="Descripción" name="description" onChange={formik.handleChange} value={formik.values.description} />
                        </div>
                        <div className={style.error}>{formik.errors.description}</div>
                    </div>
                </div>

                <div className={style.input_container}>
                    <Button text={!isEdit ? "Crear producto" : "Guardar cambios"} type="submit" onClick={formik.handleSubmit} />
                </div>

            </div>
        </div>
    )
}

export default ProductCreate